export default __webpack_public_path__ + "static/media/chevron-right.cf6b1577.svg";